import { Group, Pagination, Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { InfoBox } from "@tfg/ui"
import { isEmpty } from "lodash"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"
import { supplierMonitoringFiltersValidationType } from "@tfg/types/schemas/organization/schemas"

import { SupplierListMonitoringContactItem } from "~/pages/Brand/Suppliers/List/SupplierListMonitoringContactItem.tsx"
import { PAGE_SIZE } from "~/pages/Brand/Suppliers/List/SupplierMonitoringWrapper.tsx"
import { TransferContactModal } from "~/pages/Brand/Suppliers/List/components/TransferContactModal.tsx"

type Props = {
  suppliers: LibraryResponses.SupplierMonitoring[]
  count: number
  setPagination: (value: number) => void
  pagination: number
  setSearchSupplier: (value: string) => void
  searchSupplier: string
  setFiltersValue: (value: supplierMonitoringFiltersValidationType) => void
  filtersValue: supplierMonitoringFiltersValidationType
  type: "supplier" | "subSupplier"
}
export const SupplierMonitoring = ({
  suppliers,
  count,
  setPagination,
  pagination,
  type,
}: Props) => {
  const [opened, transferHandlers] = useDisclosure()
  const { t } = useTranslation("suppliers")
  const [pageCount, setPageCount] = useState<number>(0)
  useEffect(() => {
    setPageCount(Math.ceil(count / PAGE_SIZE))
  }, [count])

  const [contactModal, setContactModal] =
    useState<LibraryResponses.SupplierDetails>(suppliers[0].supplierInfo)

  const [transferType, setTransferType] = useState<
    "informationsRequests" | "certiticates"
  >("informationsRequests")

  return (
    <>
      <Group justify="space-between" h={32} w="100%">
        <Group>
          <Text c="gray" fz="sm">
            {t("list.countContact", {
              count,
            })}
          </Text>
        </Group>
        <Group>
          <Pagination
            size="sm"
            value={pagination}
            onChange={(page) => {
              setPagination(page)
            }}
            total={pageCount}
          />
        </Group>
      </Group>
      {isEmpty(suppliers) ? (
        <Group justify="center" mt="5%">
          <InfoBox message={t("list.noSuppliers")} />
        </Group>
      ) : (
        <>
          {suppliers.map((userSupplier) => {
            return (
              <SupplierListMonitoringContactItem
                key={userSupplier.supplierInfo.id}
                supplier={userSupplier}
                contact={userSupplier.supplierInfo}
                openModal={transferHandlers.open}
                setContactModal={setContactModal}
                type={type}
                setTransferType={setTransferType}
              />
            )
          })}
        </>
      )}
      {contactModal && type === "supplier" && (
        <TransferContactModal
          opened={opened}
          closeModal={transferHandlers.close}
          contact={contactModal}
          type={transferType}
        />
      )}
    </>
  )
}
